import {
    curry,
    prop,
    compose,
    equals,
    ifElse,
    always,
    toString,
    isNil,
    has,
} from 'ramda';
import { parseXmlDate2 } from '../../../utility/date.helpers';
import {
    FIELD_TYPE_BOOLEAN,
    FIELD_TYPE_LOOKUP,
    FIELD_TYPE_USER,
} from '../../sharePoint/sharePoint.fieldTypes';

const errorNoModifiedNode = 'Unable to find Modified field in data source.';

function refreshListItemsProcessor(listItems) {
    // FieldValue is { fieldType: SP.FieldType, values: [String] }

    // SharePointItem -> [FieldValue]
    function getFields(item) {
        return item;
    }

    // SharePointItem -> FieldValue
    var getField = curry(function (name, item) {
        return prop(name, getFields(item));
    });

    // FieldValue -> Any
    function getSimpleValue(field) {
        return field ? field.values[0] : null;
    }

    // SharePointItem -> String
    var getId = compose(getSimpleValue, getField('ID'));

    function getItem(shpItemId) {
        if (!listItems) {
            return null;
        }

        return listItems.find(compose(equals(shpItemId), getId)) || null;
    }

    // SharePointItem -> Date
    function getModifiedDateTime(item) {
        var modifiedDate = getSimpleValue(getField('Modified', item));

        if (!modifiedDate) {
            throw new Error(errorNoModifiedNode);
        }

        var parsed = parseXmlDate2(modifiedDate, { mode: 'local' });

        if (!parsed) {
            throw new Error(
                'Unexpected error: could not determine modified date for list item.',
            );
        }

        return parsed.date;
    }

    function getFieldRichTextValue(item, field) {
        return getField(field, item);
    }

    // SP.FieldType -> SharePointItem -> String -> Boolean
    var isFieldType = curry(function isFieldType(type, field) {
        return field && field.fieldType === type;
    });

    // SharePointItem -> String -> Boolean
    var isLookup = isFieldType(FIELD_TYPE_LOOKUP);
    var isPerson = isFieldType(FIELD_TYPE_USER);
    var isBoolean = isFieldType(FIELD_TYPE_BOOLEAN);

    // FieldValue -> String
    var getBooleanValueString = compose(
        ifElse(isNil, always(''), toString),
        getSimpleValue,
    );

    // FieldValue -> Number
    function getLookupValue(fieldValue) {
        var value = getSimpleValue(fieldValue);

        if (!value) {
            return '';
        }
        if (value.get_lookupId) {
            return value.get_lookupId();
        }

        return '';
    }

    function hasField(item, name) {
        return has(name, getFields(item));
    }

    return {
        getItem: getItem,
        getModifiedDateTime: getModifiedDateTime,
        getField: getField,
        getFieldRichTextValue: getFieldRichTextValue,
        isLookup: isLookup,
        isPerson: isPerson,
        isBoolean: isBoolean,
        hasField: hasField,
        getSimpleValue: getSimpleValue,
        getBooleanValueString: getBooleanValueString,
        getLookupValue: getLookupValue,
    };
}

export default refreshListItemsProcessor;
